const PropTypes = require('prop-types');
const React = require('react');
const { debounce } = require('lodash');
const Product = require('./product.jsx');
const ScrollableList = require('../shared/scrollable_list.jsx');
const UrlHelpers = require('components/shared/url_helpers.js');

const PER_PAGE = 20;
const SEARCH_DELAY = 200;

class ProductSearchForm extends React.Component {
  constructor(props) {
    super(props);

    this.isComponentMounted = false;

    this.handleSubmit = this.handleSubmit.bind(this);
    this.renderProduct = this.renderProduct.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleContainerFocus = this.handleContainerFocus.bind(this);

    if (this.props.disableDebounce) {
      this.handleChangeDebounced = this.handleChangeDebounced.bind(this);
    } else {
      this.handleChangeDebounced = debounce(this.handleChangeDebounced.bind(this), SEARCH_DELAY);
    }

    this.state = {
      results: props.results,
      hideItems: false,
    };
  }

  componentDidMount() {
    document.addEventListener('click', () => this.handleDocumentClick());
    this.isComponentMounted = true;
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.results !== this.state.results) {
      this.setState({ results: nextProps.results });
    }
  }

  componentWillUnmount() {
    document.removeEventListener('click', () => this.handleDocumentClick());
    this.isComponentMounted = false;
  }

  handleDocumentClick() {
    if (this.isComponentMounted && this.state.results.length > 0 && this.state.hideItems === false) {
      // hide the results
      this.setState({ hideItems: true });
    }
  }

  handleContainerClick(e) {
    e.nativeEvent.stopImmediatePropagation();
  }

  handleContainerFocus() {
    // show the items
    this.setState({ hideItems: false });
  }

  handleChange(e) {
    this.props.onChange(e);
    this.handleChangeDebounced(e.target.value);
  }

  handleChangeDebounced(search) {
    if (search && search.length) {
      Reverb.APIRequest.V3.get(UrlHelpers.myListingsPath, {
        query: search,
        per_page: PER_PAGE,
        not_ids: this.props.currentListingIds,
      })
      .done((response) => {
        if (this.isComponentMounted) {
          this.setState({
            results: response.listings,
            focused: null,
          });
        }
      });
    } else {
      this.setState({
        results: [],
        focused: null,
      });
    }
  }

  handleSubmit(e) {
    e.preventDefault();

    const focusedProduct = this.refs.scrollableList.focusedItem();
    if (focusedProduct) {
      this.props.productSelected(focusedProduct);
    }
  }

  renderProduct(product) {
    return <Product product={product} handleClick={this.props.productSelected} />;
  }

  render() {
    return (
      <div
        className="bd-rounded"
        onClick={this.handleContainerClick}
        onFocus={this.handleContainerFocus}
        data-product-search-form
      >
        <div className="position-relative">
          <label htmlFor="search">{this.props.labelText}</label>
          <ScrollableList
            name="search"
            className="wide mb-0"
            type="text"
            placeholder={I18n.t('js.productBundles.productSearchForm.placeholder')}
            changeEvent={this.handleChange}
            onEnter={this.handleSubmit}
            autoComplete="off"
            autoFocus="on"
            items={this.state.results}
            listClass="bundle-product-search-dropdown"
            renderItem={this.renderProduct}
            ref={'scrollableList'}
            inputValue={this.props.inputValue}
            hideItems={this.state.hideItems}
          />
        </div>
      </div>
    );
  }
}

ProductSearchForm.propTypes = {
  currentListingIds: PropTypes.array.isRequired,
  productSelected: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  labelText: PropTypes.string,
  results: PropTypes.array,
  inputValue: PropTypes.string,
  disableDebounce: PropTypes.bool,
};

ProductSearchForm.defaultProps = {
  results: [],
};

module.exports = ProductSearchForm;



// WEBPACK FOOTER //
// ./javascripts/components/product_search_form/product_search_form.jsx